export const GET_EDITORS_REQUEST = "GET_EDITORS_REQUEST";
export const GET_EDITORS_RESPONSE = "GET_EDITORS_RESPONSE";
export const DELETE_EDITORS_REQUEST = "DELETE_EDITORS_REQUEST";

export const ADD_EDITOR_REQUEST = "ADD_EDITOR_REQUEST";
export const ADD_EDITOR_RESPONSE = "ADD_EDITOR_RESPONSE";

export const EDIT_EDITOR_REQUEST = "EDIT_EDITOR_REQUEST";
export const EDIT_EDITOR_RESPONSE = "EDIT_EDITOR_RESPONSE";
